export default [
  {
    path: '/main/reportservicebyclient',
    meta: {
      tag: 'report_service_by_client',
      name: 'Relatório de Quantidade de Serviço por Cliente',
      breadcrumb: 'Relatório de Quantidade de Serviço por Cliente'
    },
    component: () => import(/* webpackChunkName: "report-service-by-client" */ '@/views/main/reports/service/amountbyclient/Index.vue'),
    children: [
      {
        path: '',
        name: 'listservicebyclient',
        meta: {
          tag: 'report_service_by_client',
          name: 'Relatório de Quantidade de Serviço por Cliente',
          menu: 'reports',
        },
        component: () => import(/* webpackChunkName: "report-service-by-client" */ '@/views/main/reports/service/amountbyclient/List.vue'),
      }
    ]
  }
]
